<script>
  import { onMount, onDestroy, getContext } from "svelte";
  import Radar from "./radar"
  import RadarMarker from "../components/RadarMarker.svelte"
  import { addOverlay, removeOverlay, getMap } from "../map";

  const flight = getContext("flight").get()
  let radar

  let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("Radar", layer, flight.overlay);
		layer.addTo(getMap())
		radar = flight.getHandler(Radar)
	});
	onDestroy(() => {
		removeOverlay(layer, flight.overlay)
		layer.removeFrom(getMap())
		
		flight.releaseHandler(Radar)
	})
</script>

{#if $radar}
{#each Object.values($radar) as radarHit (radarHit[0].trackNumber)}
  <RadarMarker info={radarHit} {layer} />
{/each}
{/if}